import { Component, computed, effect, inject, input, output, signal, untracked } from '@angular/core';
import { StyleImage } from 'src/app/interfaces/style-image';
import { StyleImagesProviderService } from 'src/app/providers/style-images/style-images.provider.service';
import { SelectedAttributeService } from '../../../services/selected-attribute.service';
import { LoadingService } from 'src/app/services/loading/loading.service';
import { assert } from 'src/app/utils/assert.util';
import { getAWSAssetURL } from 'src/app/constants/assets';
import { MatDialog } from '@angular/material/dialog';
import { StyleImageGalleryComponent } from '../../style-image-gallery/style-image-gallery.component';
import { ConfiguredItem } from 'src/app/interfaces/configured-item';

@Component({
  selector: 'app-style-image-thumbnails',
  templateUrl: './style-image-thumbnails.component.html',
  styleUrl: './style-image-thumbnails.component.scss'
})
export class StyleImageThumbnailsComponent {
  private matDialog = inject(MatDialog);
  private styleImagesProvider = inject(StyleImagesProviderService);
  private selectedAttributeService = inject(SelectedAttributeService);
  private loadingService = inject(LoadingService);
  images = input<StyleImage[]>([]);
  // images = signal<StyleImage[]>([]);
  tinyThumbnailURLs = computed(() => this.images().slice(0,3).map(image => getAWSAssetURL(image.fileName.replace('{{size}}', 'tiny'))));
  isOpen = output<boolean>();
  // prevItem = signal<ConfiguredItem>({
  //     design: null,
  //     form: null,
  //     primaryMaterial: null,
  //     secondaryMaterial: null,
  //     width: null,
  //     engravingType: null,
  //     engravingText: null,
  //     size: null,
  //     gemstoneType: null,
  //     gemstoneArrangement: null,
  //     gemstoneSize: null,
  //     gemstoneSetting: null,
  //     gemstoneShape: null
  //   });

  // constructor() {
  //   effect(async () => {
  //     const prevItem = untracked(() => this.prevItem());
  //     const configuredItem = this.selectedAttributeService.configuredItem();
  //     const changes = (Object.keys(configuredItem) as (keyof ConfiguredItem)[]).reduce((changes, key) => {
  //       if (configuredItem[key] !== prevItem[key]) {
  //         changes.push(key);
  //       }
  //       return changes;
  //     }, [] as string[]);

  //     if (!changes.some(k => k.includes('size')) && !changes.some(k => k.includes('engraving'))) {
  //       this.loadingService.load('StyleImageThumbnails::load');
  //       const images = await this.styleImagesProvider.getP4s(configuredItem);
  //       this.images.set(images);
  //       this.loadingService.done('StyleImageThumbnails::load');
  //     }
  //     this.prevItem.set(configuredItem);
  //   }, { allowSignalWrites: true });
  // }

  openGallery(image: StyleImage) {
    this.isOpen.emit(true);
    this.matDialog.open(StyleImageGalleryComponent, { data: { title: this.selectedAttributeService.configuredItem().design?.displayName, selectedImage: image, images: this.images() }, panelClass: 'GalleryGlobal', enterAnimationDuration: '0ms', exitAnimationDuration: '0ms', autoFocus: false }).afterClosed().subscribe(() => this.isOpen.emit(false));
  }
}
